"use client";

import { CheckCircle } from "lucide-react";
import Image from "next/image";
import React from "react";
import BusinessForm from "./BusinessForm";
import PortfolioStats from "@/components/PortfolioStats";

const BusinessWithUs = () => {
  return (
    <>
      <section className="about-us-page">
        <div className="container">
          <div className="text-center">
            <h1 className="inner-first-heading !text-[23px] mb-3">
              Partner With Us
            </h1>
            <div
              className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4"
              style={{ background: "#f26624" }}
            ></div>
            <div className="about-mission-vision mb-5">
              <div className="vision-mission-container">
                <div className="business-form">
                  <BusinessForm></BusinessForm>
                </div>
              </div>
            </div>
            <p className="text-left">
              When you partner with us, you gain access to our unparalleled
              expertise in key areas of Sales and Operations. Our powerful
              brands instill consumer confidence and loyalty. Beginning with
              industry best-practice models, we continually seek to refine
              systems and processes and integrate our operations to increase
              efficiency and reduce costs.
            </p>
          </div>
          <div className="row mt-4">
            <div className="col-md-12 align-self-center">
              <h3 className="inner-third-heading mb-3 !text-[14px]">
                We support you in the following areas:
              </h3>
              <h6 className="d-flex gap-2 mb-3 !text-[14px]">
                <CheckCircle size={16}></CheckCircle> Sales & Distribution
              </h6>
              <h6 className="d-flex gap-2 mb-3 !text-[14px]">
                <CheckCircle size={16}></CheckCircle> Revenue Management
              </h6>
              <h6 className="d-flex gap-2 mb-3 !text-[14px]">
                <CheckCircle size={16}></CheckCircle> Marketing
              </h6>
              <h6 className="d-flex gap-2 mb-3 !text-[14px]">
                <CheckCircle size={16}></CheckCircle> Operations
              </h6>
              <h6 className="d-flex gap-2 mb-4 !text-[14px]">
                <CheckCircle size={16}></CheckCircle> Training and Development
              </h6>
              <p>
                Want your hotel to be part of the leading young and vibrant
                group? Join us and see your hotel open up to a new world of
                hospitality. Let us manage your property and unlock a world of
                business opportunities for you. You dream of your hotel&apos;s
                future, we make it come alive!
              </p>
            </div>
          </div>
          <div className="mb-4 pt-4">
            <PortfolioStats />
          </div>
        </div>
      </section>

      <style jsx>
        {`
          .vision-mission-container {
            display: block;
            width: 100%;
            padding: 40px;
            border-radius: 8px;
            color: black;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
          }

          .vision-section,
          .mission-section {
            width: 45%;
          }

          .vision-mission-container h2 {
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            margin-bottom: 10px;
          }

          .vision-mission-container p {
            color: #fff;
            line-height: 1.6;
          }

          .vision-section {
            border-right: 2px solid #ccc;
            padding-right: 20px;
          }

          .vision-section h2,
          .mission-section h2 {
            color: #fff;
          }

          .vision-mission-container h2 {
            text-align: left;
          }

          @media (max-width: 767px) {
            .vision-section,
            .mission-section {
              width: 100%;
            }
            .vision-section {
              border-right: none;
              padding-right: 0px;
            }

            .vision-mission-container {
              display: block;
              padding: 20px;
            }
          }
        `}
      </style>
    </>
  );
};

export default BusinessWithUs;
